/**
 * Confidential crypto primitives, sourced from the @fairblock/stabletrust SDK.
 *
 * This replaces the previously vendored, local WASM module
 * (`src/pkg/confidential_transfer_proof_generation.js`). The SDK ships the same
 * wasm-bindgen module under its `./wasm` export, so these functions are
 * behaviourally identical (including the proof `randomness` output that the IBE
 * auditor-encryption flow depends on) while removing the duplicated copy from
 * the app.
 *
 * `init` (default export) lazily instantiates the WASM binary. It is safe to
 * call repeatedly — the module memoises initialisation — and all importers
 * share a single underlying instance.
 */
import init, {
  encrypt_amount,
  decrypt_ciphertext,
  generate_transfer_proof,
  generate_withdraw_proof,
  generate_deterministic_keypair,
  decode_transfer_proof,
} from "@fairblock/stabletrust/wasm";

export {
  encrypt_amount,
  decrypt_ciphertext,
  generate_transfer_proof,
  generate_withdraw_proof,
  generate_deterministic_keypair,
  decode_transfer_proof,
};

export default init;
